



// import React, { useState, useEffect } from 'react';
// import {
//     getAllDeliveryOrders,
//     getDeliveryOrderById
// } from "../../../Servicefile/ordermanagementservice.jsx";
// // Inline loader hook (same as Userdetails component)
// const useInlineLoader = () => {
//     const [loading, setLoading] = useState(false);
//     const [fadeOut, setFadeOut] = useState(false);

//     const showLoader = () => {
//         setFadeOut(false);
//         setLoading(true);
//     };

//     const hideLoader = () => {
//         setFadeOut(true);
//         setTimeout(() => {
//             setLoading(false);
//             setFadeOut(false);
//         }, 500);
//     };

//     return { showLoader, hideLoader, loading, fadeOut };
// };

// // Loader Component (same as Userdetails component)
// const Loader = ({ loading, fadeOut, text = "Loading..." }) => {
//     if (!loading) return null;

//     return (
//         <div style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: 'rgba(0,0,0,0.95)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             zIndex: 999999,
//             transition: 'opacity 0.4s ease',
//             fontFamily: 'Arial, sans-serif',
//             opacity: fadeOut ? 0 : 1,
//             pointerEvents: fadeOut ? 'none' : 'auto'
//         }}>
//             <div style={{ textAlign: 'center' }}>
//                 <div style={{
//                     fontSize: '2rem',
//                     fontWeight: 900,
//                     letterSpacing: '6px',
//                     marginBottom: '30px',
//                 }}>
//                     {"MAAMAAS".split("").map((l, i) => (
//                         <span
//                             key={i}
//                             style={{
//                                 display: 'inline-block',
//                                 opacity: 0,
//                                 transform: 'translateY(30px)',
//                                 animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
//                                 color: '#e50914',
//                             }}
//                         >
//                             {l}
//                         </span>
//                     ))}
//                 </div>

//                 <div style={{
//                     width: '280px',
//                     height: '4px',
//                     background: 'rgba(255,255,255,0.2)',
//                     overflow: 'hidden',
//                     margin: '0 auto',
//                 }}>
//                     <div style={{
//                         width: '40%',
//                         height: '100%',
//                         background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
//                         animation: 'progress 1.8s infinite',
//                     }}></div>
//                 </div>

//                 <div style={{
//                     marginTop: '20px',
//                     color: '#aaa',
//                     fontSize: '14px',
//                 }}>
//                     {text}
//                 </div>
//             </div>
//         </div>
//     );
// };

// const Logisticsorders = () => {
//     const [showDetails, setShowDetails] = useState({});
//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [cancelLoading, setCancelLoading] = useState({});

//     // Use inline loader (same as Userdetails component)
//     const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();

//     const isMobile = window.innerWidth < 768;

//     // =================== Static Data ===================
//     // Keeping this as fallback data
//     const staticOrders = [

//     ];

//     // UPDATED: Changed order stages to 3 stages
//     const orderStages = ["Order accepted", "Order onthe way", "Order delivered"];

//     const styles = {
//         card: { border: '1px solid #ccc', padding: '16px', margin: '16px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)" },
//         header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
//         orderId: { margin: 0, fontWeight: "bold" },
//         date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
//         pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold" },
//         cancelBtn: {
//             background: '#dc3545',
//             color: '#fff',
//             border: 'none',
//             padding: '6px 12px',
//             cursor: 'pointer',
//             borderRadius: '5px',
//             fontWeight: "bold",
//             marginLeft: '10px'
//         },
//         tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
//         statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
//         arrow: { margin: '0 5px' },
//         dropdownBtn: { background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' },
//     };

//     // Fetch orders from API
//     useEffect(() => {
//         fetchOrders();
//     }, []);

//     const fetchOrders = async () => {

//         try {

//             setLoading(true);

//             showLoader();

//             const token =
//                 localStorage.getItem("authToken");

//             const data =
//                 await getAllDeliveryOrders(token);

//             const filteredData =
//                 Array.isArray(data)
//                     ? data.filter(
//                         item =>
//                             item.status !== "DELIVERED" &&
//                             item.status !== "REJECTED"
//                     )
//                     : [];

//             const transformedOrders =
//                 filteredData.map(apiOrder => ({
//                     orderId:
//                         apiOrder.orderId ||
//                         apiOrder.id,

//                     order: [
//                         {
//                             dishName:
//                                 apiOrder.items ||
//                                 "Delivery",

//                             quantity:
//                                 apiOrder.deliveryAddress ||
//                                 "Address",

//                             to: "Delivery",

//                             price:
//                                 apiOrder.earning || 0,

//                             status: "Okay",
//                         },
//                     ],

//                     orderDateAndTime:
//                         apiOrder.createdAt ||
//                         new Date().toISOString(),

//                     status:
//                         apiOrder.status ||
//                         "OFFERED",

//                     apiData: apiOrder,
//                 }));

//             setOrders(transformedOrders);

//         } catch (err) {

//             console.error(
//                 "Error fetching orders:",
//                 err
//             );

//         } finally {

//             setLoading(false);

//             hideLoader();
//         }
//     };

//     // Fetch order by ID
//     const fetchOrderById = async (orderId) => {

//         try {

//             const token =
//                 localStorage.getItem("authToken");

//             // 🔥 SERVICE API
//             const data =
//                 await getDeliveryOrderById(
//                     orderId,
//                     token
//                 );

//             return data;

//         } catch (err) {

//             console.error(
//                 "Error fetching order by ID:",
//                 err
//             );

//             return null;
//         }
//     };

//     // Cancel/Reject order
//     const handleCancelOrder = async (orderId) => {
//         if (!window.confirm("Are you sure you want to reject this order?")) return;

//         try {
//             setCancelLoading(prev => ({ ...prev, [orderId]: true }));

//             const token = localStorage.getItem("authToken");

//             const order = orders.find(o => o.orderId === orderId);
//             if (!order || !order.apiData) {
//                 throw new Error("Order data not available");
//             }

//             const partnerId =
//                 order.apiData.partnerId ||
//                 order.apiData.deliveryPartnerId;

//             if (!partnerId) {
//                 throw new Error("Partner ID not found");
//             }

//             // ✅ SINGLE-LINE URL (NO SPACES)
//             const url = `https://backend.maamaas.com/delivery/api/update/offer/status?offerId=${orderId}&partnerId=${partnerId}&vendorOtp=1&userOtp=1&status=REJECTED`;

//             const response = await fetch(url, {
//                 method: "PUT",
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Content-Type": "application/json",
//                 },
//             });

//             if (!response.ok) {
//                 throw new Error(`Reject API failed (${response.status})`);
//             }

//             // ✅ Remove order from UI
//             setOrders(prev => prev.filter(o => o.orderId !== orderId));

//             alert("Order rejected successfully");
//         } catch (err) {
//             console.error(err);
//             alert(err.message);
//         } finally {
//             setCancelLoading(prev => ({ ...prev, [orderId]: false }));
//         }
//     };



//     // Refresh orders function
//     const handleRefresh = () => {
//         fetchOrders();
//     };

//     return (
//         <div className="container-fluid">
//             {/* Global Loader (same as Userdetails component) */}
//             <Loader loading={globalLoading} fadeOut={fadeOut} text="Loading logistics orders..." />

//             {/* Add loader animations to existing style */}
//             <style>{`
//                 @keyframes letterAnim {
//                     0% { opacity: 0; transform: translateY(30px); }
//                     100% { opacity: 1; transform: translateY(0); }
//                 }

//                 @keyframes progress {
//                     0% { transform: translateX(-100%); }
//                     100% { transform: translateX(250%); }
//                 }
//             `}</style>

//             <div className="row">
//                 <div className="col-lg-11" style={{ maxHeight: "80vh", overflowY: "auto", overflowX: "hidden" }}>
//                     {/* Refresh Button */}
//                     <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '16px' }}>
//                         <button
//                             onClick={handleRefresh}
//                             style={{
//                                 background: 'rgb(230 109 51)',
//                                 color: '#fff',
//                                 border: 'none',
//                                 padding: '8px 16px',
//                                 borderRadius: '5px',
//                                 cursor: 'pointer',
//                                 fontWeight: 'bold',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '8px'
//                             }}
//                         >
//                             <span>Refresh Orders</span>
//                         </button>
//                     </div>

//                     {loading ? (
//                         <div style={{ textAlign: 'center', padding: '20px' }}>
//                             <p>Loading orders...</p>
//                         </div>
//                     ) : error ? (
//                         <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
//                             <p>Error: {error}</p>
//                             <p>Showing static data...</p>
//                         </div>
//                     ) : (
//                         orders.map((order) => {
//                             const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
//                             const orderId = order.orderId || order.cartId;
//                             const isCancelled = order.status === 'REJECTED';

//                             return (
//                                 <div key={orderId} style={styles.card}>
//                                     <div style={styles.header}>
//                                         <h3 style={styles.orderId}>Order ID: {orderId}</h3>
//                                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                                             {/* <button style={styles.pickupBtn}>
//                                                 {order.service || order.orderType || 'Service'}
//                                             </button> */}

//                                             {/* Reject Button - Only show if not already rejected */}
//                                             {!isCancelled && (
//                                                 <button
//                                                     style={styles.cancelBtn}
//                                                     onClick={() => handleCancelOrder(orderId)}
//                                                     disabled={cancelLoading[orderId]}
//                                                 >
//                                                     {cancelLoading[orderId] ? 'Rejecting...' : 'Reject'}
//                                                 </button>
//                                             )}

//                                             <button
//                                                 style={styles.dropdownBtn}
//                                                 onClick={() =>
//                                                     setShowDetails((prev) => ({
//                                                         ...prev,
//                                                         [orderId]: !prev[orderId],
//                                                     }))
//                                                 }
//                                             >
//                                                 {showDetails[orderId] ? '▲' : '▼'}
//                                             </button>
//                                         </div>
//                                     </div>

//                                     {showDetails[orderId] && (
//                                         <>
//                                             <p style={styles.date}>
//                                                 {order.orderDateAndTime ? (() => {
//                                                     const dateObj = new Date(order.orderDateAndTime);
//                                                     const date = dateObj.toLocaleDateString('en-IN', {
//                                                         day: '2-digit',
//                                                         month: '2-digit',
//                                                         year: 'numeric',
//                                                     });
//                                                     const time = dateObj.toLocaleTimeString('en-IN', {
//                                                         hour: '2-digit',
//                                                         minute: '2-digit',
//                                                         hour12: true,
//                                                     });
//                                                     return (
//                                                         <>
//                                                             <span style={{ color: 'black' }}>Date: </span>
//                                                             <span style={{ color: 'white' }}>{date}</span>
//                                                             <br />
//                                                             <span style={{ color: 'black' }}>Time: </span>
//                                                             <span style={{ color: 'white' }}>{time}</span>
//                                                         </>
//                                                     );
//                                                 })() : 'N/A'}
//                                             </p>

//                                             <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
//                                                 <thead>
//                                                     <tr style={{ backgroundColor: 'rgb(230 109 51)', textAlign: 'center' }}>
//                                                         <th style={{ padding: '8px', border: '1px solid #ddd' }}>S.No</th>
//                                                         <th style={{ padding: '8px', border: '1px solid #ddd' }}>Vehicle</th>
//                                                         <th style={{ padding: '8px', border: '1px solid #ddd' }}>From</th>
//                                                         <th style={{ padding: '8px', border: '1px solid #ddd' }}>To</th>
//                                                         <th style={{ padding: '8px', border: '1px solid #ddd' }}>Earning</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {orderItems.map((item, index) =>
//                                                         item.status === "Okay" || item.orderType === "TABLE_DINE_IN" ? (
//                                                             <tr key={index} style={{ borderBottom: '1px solid #eee', fontWeight: 'bold', backgroundColor: '#d4edda' }}>
//                                                                 <td style={{ padding: '8px', border: '1px solid #ddd' }}>{index + 1}</td>
//                                                                 <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.dishName}</td>
//                                                                 <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.quantity || 1}</td>
//                                                                 <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.to}</td>
//                                                                 <td style={{ padding: '8px', border: '1px solid #ddd' }}>₹{item.price}</td>
//                                                             </tr>
//                                                         ) : null
//                                                     )}
//                                                 </tbody>
//                                             </table>

//                                             {/* Additional API Data Display */}
//                                             {order.apiData && (
//                                                 <div style={{ marginTop: '16px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
//                                                     <h4 style={{ marginBottom: '8px', color: 'rgb(230 109 51)' }}>Delivery Details</h4>
//                                                     <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '8px' }}>
//                                                         {order.apiData.userName && (
//                                                             <div>
//                                                                 <strong>User:</strong> {order.apiData.userName} ({order.apiData.userPhone})
//                                                             </div>
//                                                         )}
//                                                         {order.apiData.vendorRestaurentname && (
//                                                             <div>
//                                                                 <strong>Vendor:</strong> {order.apiData.vendorRestaurentname}
//                                                             </div>
//                                                         )}
//                                                         {order.apiData.deliveryDistanceKm && (
//                                                             <div>
//                                                                 <strong>Distance:</strong> {parseFloat(order.apiData.deliveryDistanceKm).toFixed(2)} km
//                                                             </div>
//                                                         )}
//                                                         {order.apiData.status && (
//                                                             <div style={{ color: order.apiData.status === 'REJECTED' ? '#dc3545' : 'inherit' }}>
//                                                                 <strong>Status:</strong> {order.apiData.status}
//                                                             </div>
//                                                         )}
//                                                         {order.apiData.vehicleStatus && (
//                                                             <div>
//                                                                 <strong>Vehicle:</strong> {order.apiData.vehicleStatus}
//                                                             </div>
//                                                         )}
//                                                         {order.apiData.deliveryPartnerName && (
//                                                             <div>
//                                                                 <strong>Delivery Partner:</strong> {order.apiData.deliveryPartnerName}
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </>
//                                     )}

//                                     <div style={{ ...styles.tracker, display: 'flex', justifyContent: 'center', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '5px' : '0px', alignItems: 'center' }}>
//                                         {orderStages.map((stage, index) => {
//                                             // UPDATED: Map API statuses to new 3-stage order tracking
//                                             const statusToStage = {
//                                                 OFFERED: "Order accepted",
//                                                 ACCEPTED: "Order accepted",
//                                                 BEING_PREPARED: "Order onthe way",
//                                                 ORDER_IS_READY: "Order onthe way",
//                                                 WAITING_FOR_PICKUP: "Order onthe way",
//                                                 PICKED_UP: "Order onthe way",
//                                                 ON_THE_WAY: "Order onthe way",
//                                                 DELIVERED: "Order delivered",
//                                                 COMPLETED: "Order delivered",
//                                                 PROCESSING: "Order accepted",
//                                                 REJECTED: "Order accepted", // Rejected orders show only first stage
//                                             };

//                                             let isActive = false;
//                                             if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
//                                                 const relevantStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"];
//                                                 const itemStageIndexes = order.cartItems
//                                                     .filter(item => relevantStatuses.includes(item.orderStatus))
//                                                     .map(item => orderStages.indexOf(statusToStage[item.orderStatus] || "Order accepted"))
//                                                     .filter(i => i !== -1);
//                                                 const highestStageIndex = itemStageIndexes.length > 0 ? Math.max(...itemStageIndexes) : 0;
//                                                 isActive = index <= highestStageIndex;
//                                             } else {
//                                                 // For rejected orders, only show the first stage
//                                                 if (order.status === 'REJECTED') {
//                                                     isActive = index === 0;
//                                                 } else {
//                                                     const currentStageIndex = orderStages.indexOf(statusToStage[order.status] || "Order accepted");
//                                                     isActive = index <= currentStageIndex;
//                                                 }
//                                             }

//                                             return (
//                                                 <React.Fragment key={index}>
//                                                     <div style={{
//                                                         ...styles.statusBox,
//                                                         backgroundColor: isActive ? (order.status === 'REJECTED' && index === 0 ? "#dc3545" : "green") : "#f0f0f0",
//                                                         color: isActive ? "white" : "black",
//                                                         borderRadius: "6px",
//                                                         padding: "8px 12px",
//                                                         fontWeight: "bold",
//                                                         textTransform: "uppercase",
//                                                         transition: "0.3s"
//                                                     }}>
//                                                         {order.status === 'REJECTED' && index === 0 ? 'REJECTED' : stage}
//                                                     </div>
//                                                     {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
//                                                 </React.Fragment>
//                                             );
//                                         })}
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Logisticsorders;





import React, { useState, useEffect } from 'react';
import {
    getAllDeliveryOrders,
    getDeliveryOrderById
} from "../../../Servicefile/ordermanagementservice.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    Expand: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9" />
        </svg>
    ),
    Collapse: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="18 15 12 9 6 15" />
        </svg>
    ),
    Cancel: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Order: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Clock: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    User: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Location: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Truck: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <rect x="1" y="3" width="15" height="13" />
            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
            <circle cx="5.5" cy="18" r="2.5" />
            <circle cx="18.5" cy="18" r="2.5" />
        </svg>
    ),
    Check: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',

        borderRadius: '16px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    card: {
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        marginBottom: '16px',
        overflow: 'hidden',
        border: '1px solid #edf2f7',
        transition: 'all 0.3s ease'
    },
    cardHeader: {
        padding: '16px 20px',
        background: 'linear-gradient(135deg, #f46b45 0%, #eea849 100%)',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px'
    },
    cardBody: {
        padding: '20px'
    },
    orderId: {
        fontSize: '16px',
        fontWeight: '700',
        margin: 0,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    infoGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '12px',
        marginBottom: '16px'
    },
    infoItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        color: '#2d3748',
        padding: '6px 0'
    },
    infoLabel: {
        fontWeight: '600',
        color: '#4a5568',
        minWidth: '50px'
    },
    infoValue: {
        fontWeight: '500',
        color: '#1a202c'
    },
    tableWrapper: {
        borderRadius: '8px',
        border: '1px solid #edf2f7',
        overflow: 'auto',
        marginBottom: '16px'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse'
    },
    th: {
        padding: '10px 14px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        textAlign: 'center',
        fontSize: '13px'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    statusActive: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusPending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    statusRejected: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    statusDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    trackerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 0',
        flexWrap: 'wrap'
    },
    trackerStep: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    stepBadge: {
        padding: '6px 16px',
        borderRadius: '20px',
        fontWeight: '600',
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.3px',
        transition: 'all 0.3s ease'
    },
    stepActive: {
        background: 'rgb(230 109 51)',
        color: 'white',
        boxShadow: '0 2px 8px rgba(230, 109, 51, 0.3)'
    },
    stepCompleted: {
        background: '#48bb78',
        color: 'white'
    },
    stepInactive: {
        background: '#edf2f7',
        color: '#a0aec0'
    },
    stepRejected: {
        background: '#fc8181',
        color: 'white'
    },
    stepConnector: {
        width: '30px',
        height: '2px',
        background: '#e2e8f0'
    },
    stepConnectorActive: {
        background: 'rgb(230 109 51)'
    },
    button: {
        padding: '6px 16px',
        borderRadius: '6px',
        border: 'none',
        fontWeight: '600',
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '34px',
        whiteSpace: 'nowrap'
    },
    buttonDanger: {
        background: '#fc8181',
        color: 'white'
    },
    buttonDangerDisabled: {
        background: '#e2e8f0',
        color: '#a0aec0',
        cursor: 'not-allowed'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    expandButton: {
        background: 'rgba(255,255,255,0.2)',
        border: 'none',
        borderRadius: '6px',
        padding: '6px 10px',
        cursor: 'pointer',
        color: 'white',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '12px'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    statsBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '8px 0',
        fontSize: '12px',
        color: '#718096',
        flexWrap: 'wrap'
    },
    statItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    statNumber: {
        fontWeight: '600',
        color: '#2d3748'
    },
    detailsSection: {
        marginTop: '16px',
        padding: '16px',
        background: '#f7fafc',
        borderRadius: '8px',
        border: '1px solid #edf2f7'
    },
    detailsTitle: {
        fontSize: '14px',
        fontWeight: '600',
        color: 'rgb(230 109 51)',
        marginBottom: '10px'
    }
};

// Loader Component
const Loader = ({ loading, fadeOut, text = "Loading..." }) => {
    if (!loading) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.95)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 999999,
            transition: 'opacity 0.4s ease',
            fontFamily: 'Arial, sans-serif',
            opacity: fadeOut ? 0 : 1,
            pointerEvents: fadeOut ? 'none' : 'auto'
        }}>
            <div style={{ textAlign: 'center' }}>
                <div style={{
                    fontSize: '2rem',
                    fontWeight: 900,
                    letterSpacing: '6px',
                    marginBottom: '30px',
                }}>
                    {"MAAMAAS".split("").map((l, i) => (
                        <span
                            key={i}
                            style={{
                                display: 'inline-block',
                                opacity: 0,
                                transform: 'translateY(30px)',
                                animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
                                color: '#e50914',
                            }}
                        >
                            {l}
                        </span>
                    ))}
                </div>

                <div style={{
                    width: '280px',
                    height: '4px',
                    background: 'rgba(255,255,255,0.2)',
                    overflow: 'hidden',
                    margin: '0 auto',
                }}>
                    <div style={{
                        width: '40%',
                        height: '100%',
                        background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
                        animation: 'progress 1.8s infinite',
                    }}></div>
                </div>

                <div style={{
                    marginTop: '20px',
                    color: '#aaa',
                    fontSize: '14px',
                }}>
                    {text}
                </div>
            </div>
        </div>
    );
};

// Inline loader hook
const useInlineLoader = () => {
    const [loading, setLoading] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    const showLoader = () => {
        setFadeOut(false);
        setLoading(true);
    };

    const hideLoader = () => {
        setFadeOut(true);
        setTimeout(() => {
            setLoading(false);
            setFadeOut(false);
        }, 500);
    };

    return { showLoader, hideLoader, loading, fadeOut };
};

const Logisticsorders = () => {
    const [showDetails, setShowDetails] = useState({});
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [cancelLoading, setCancelLoading] = useState({});
    const [isMobile, setIsMobile] = useState(false);

    const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const orderStages = ["Order accepted", "Order on the way", "Order delivered"];

    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        try {
            setLoading(true);
            showLoader();

            const token = localStorage.getItem("authToken");
            const data = await getAllDeliveryOrders(token);

            const filteredData = Array.isArray(data)
                ? data.filter(item => item.status !== "DELIVERED" && item.status !== "REJECTED")
                : [];

            const transformedOrders = filteredData.map(apiOrder => ({
                orderId: apiOrder.orderId || apiOrder.id,
                order: [{
                    dishName: apiOrder.items || "Delivery",
                    quantity: apiOrder.deliveryAddress || "Address",
                    to: "Delivery",
                    price: apiOrder.earning || 0,
                    status: "Okay",
                }],
                orderDateAndTime: apiOrder.createdAt || new Date().toISOString(),
                status: apiOrder.status || "OFFERED",
                apiData: apiOrder,
            }));

            setOrders(transformedOrders);
        } catch (err) {
            console.error("Error fetching orders:", err);
            setError(err.message);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    const handleCancelOrder = async (orderId) => {
        if (!window.confirm("Are you sure you want to reject this order?")) return;

        try {
            setCancelLoading(prev => ({ ...prev, [orderId]: true }));

            const token = localStorage.getItem("authToken");
            const order = orders.find(o => o.orderId === orderId);
            if (!order || !order.apiData) {
                throw new Error("Order data not available");
            }

            const partnerId = order.apiData.partnerId || order.apiData.deliveryPartnerId;
            if (!partnerId) {
                throw new Error("Partner ID not found");
            }

            const url = `https://backend.maamaas.com/delivery/api/update/offer/status?offerId=${orderId}&partnerId=${partnerId}&vendorOtp=1&userOtp=1&status=REJECTED`;

            const response = await fetch(url, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`Reject API failed (${response.status})`);
            }

            setOrders(prev => prev.filter(o => o.orderId !== orderId));
            alert("Order rejected successfully");
        } catch (err) {
            console.error(err);
            alert(err.message);
        } finally {
            setCancelLoading(prev => ({ ...prev, [orderId]: false }));
        }
    };

    const handleRefresh = () => fetchOrders();

    const getStatusBadge = (status) => {
        if (!status) return styles.statusDefault;
        const lower = status.toLowerCase();
        if (lower === 'accepted' || lower === 'delivered' || lower === 'completed') return styles.statusActive;
        if (lower === 'rejected' || lower === 'cancelled') return styles.statusRejected;
        if (lower === 'offered' || lower === 'pending' || lower === 'processing') return styles.statusPending;
        return styles.statusDefault;
    };

    const getStepStatus = (order, stage, index) => {
        const statusToStage = {
            OFFERED: "Order accepted",
            ACCEPTED: "Order accepted",
            BEING_PREPARED: "Order on the way",
            ORDER_IS_READY: "Order on the way",
            WAITING_FOR_PICKUP: "Order on the way",
            PICKED_UP: "Order on the way",
            ON_THE_WAY: "Order on the way",
            DELIVERED: "Order delivered",
            COMPLETED: "Order delivered",
            PROCESSING: "Order accepted",
            REJECTED: "Order accepted",
        };

        if (order.status === 'REJECTED') {
            return index === 0 ? 'rejected' : 'inactive';
        }

        const currentStageIndex = orderStages.indexOf(statusToStage[order.status] || "Order accepted");
        if (index < currentStageIndex) return 'completed';
        if (index === currentStageIndex) return 'active';
        return 'inactive';
    };

    // Calculate stats
    const totalOrders = orders.length;
    const totalEarnings = orders.reduce((sum, order) => {
        const earnings = order.apiData?.earning || 0;
        return sum + earnings;
    }, 0);

    return (
        <div style={styles.container}>
            <Loader loading={globalLoading} fadeOut={fadeOut} text="Loading logistics orders..." />

            <style>{`
                @keyframes letterAnim {
                    0% { opacity: 0; transform: translateY(30px); }
                    100% { opacity: 1; transform: translateY(0); }
                }
                @keyframes progress {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(250%); }
                }
                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                
                .card-enter {
                    animation: fadeInUp 0.4s ease forwards;
                }
                
                @media (max-width: 768px) {
                    .tracker-container {
                        flex-direction: column !important;
                        gap: 4px !important;
                    }
                    .tracker-step {
                        width: 100% !important;
                        justify-content: center !important;
                    }
                    .step-connector {
                        display: none !important;
                    }
                    .info-grid {
                        grid-template-columns: 1fr !important;
                    }
                }
                
                @media (max-width: 480px) {
                    .card-header {
                        flex-direction: column !important;
                        align-items: flex-start !important;
                    }
                    .order-id {
                        font-size: 14px !important;
                    }
                    .table-container table {
                        font-size: 11px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 6px 8px !important;
                        font-size: 10px !important;
                    }
                    .step-badge {
                        font-size: 10px !important;
                        padding: 4px 10px !important;
                    }
                    .stats-bar {
                        gap: 4px !important;
                    }
                    .stats-bar span {
                        font-size: 10px !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: #a1a1a1;
                }
            `}</style>


            {/* Orders List */}
            <div style={{ maxHeight: 'calc(90vh - 250px)', overflowY: 'auto', paddingRight: '4px' }}>
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p style={{ marginTop: '16px', color: '#718096' }}>Loading orders...</p>
                    </div>
                ) : orders.length === 0 ? (
                    <div style={styles.emptyState}>
                        <Icons.NoData />
                        <div style={styles.emptyStateText}>No active orders</div>
                        <div style={styles.emptyStateSubtext}>All orders have been processed or rejected</div>
                    </div>
                ) : (
                    orders.map((order, idx) => {
                        const orderId = order.orderId;
                        const isExpanded = showDetails[orderId] || false;
                        const isRejected = order.status === 'REJECTED';
                        const orderItems = order.order || [];

                        return (
                            <div key={orderId} style={styles.card} className="card-enter">
                                {/* Card Header */}
                                <div style={styles.cardHeader}>
                                    <div style={styles.orderId}>
                                        <Icons.Order /> Order: {orderId}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {!isRejected && (
                                            <button
                                                onClick={() => handleCancelOrder(orderId)}
                                                disabled={cancelLoading[orderId]}
                                                style={{
                                                    ...styles.button,
                                                    ...(cancelLoading[orderId] ? styles.buttonDangerDisabled : styles.buttonDanger)
                                                }}
                                            >
                                                <Icons.Cancel /> {cancelLoading[orderId] ? 'Rejecting...' : 'Reject'}
                                            </button>
                                        )}
                                        <button
                                            style={styles.expandButton}
                                            onClick={() => setShowDetails(prev => ({ ...prev, [orderId]: !prev[orderId] }))}
                                        >
                                            {isExpanded ? <Icons.Collapse /> : <Icons.Expand />}
                                            {isExpanded ? 'Hide' : 'View'}
                                        </button>
                                    </div>
                                </div>

                                {/* Card Body */}
                                <div style={styles.cardBody}>
                                    {/* Basic Info */}
                                    <div style={styles.infoGrid}>
                                        <div style={styles.infoItem}>
                                            <Icons.Calendar /> <span style={styles.infoLabel}>Date:</span>
                                            <span style={styles.infoValue}>
                                                {order.orderDateAndTime ? new Date(order.orderDateAndTime).toLocaleDateString('en-GB') : 'N/A'}
                                            </span>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <Icons.Clock /> <span style={styles.infoLabel}>Time:</span>
                                            <span style={styles.infoValue}>
                                                {order.orderDateAndTime ? new Date(order.orderDateAndTime).toLocaleTimeString('en-IN', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                }) : 'N/A'}
                                            </span>
                                        </div>
                                        <div style={styles.infoItem}>
                                            <span style={styles.infoLabel}>Status:</span>
                                            <span style={{ ...styles.statusBadge, ...getStatusBadge(order.status) }}>
                                                {order.status || 'N/A'}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Order Tracker */}
                                    <div style={styles.trackerContainer} className="tracker-container">
                                        {orderStages.map((stage, index) => {
                                            const stepStatus = getStepStatus(order, stage, index);
                                            let stepStyle = styles.stepInactive;
                                            if (stepStatus === 'completed') stepStyle = styles.stepCompleted;
                                            else if (stepStatus === 'active') stepStyle = styles.stepActive;
                                            else if (stepStatus === 'rejected') stepStyle = styles.stepRejected;

                                            return (
                                                <div key={index} style={styles.trackerStep} className="tracker-step">
                                                    <div style={{ ...styles.stepBadge, ...stepStyle }}>
                                                        {stepStatus === 'rejected' ? 'REJECTED' : stage}
                                                    </div>
                                                    {index < orderStages.length - 1 && (
                                                        <div style={{
                                                            ...styles.stepConnector,
                                                            ...(stepStatus === 'completed' || stepStatus === 'active' ? styles.stepConnectorActive : {})
                                                        }} className="step-connector" />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* Expandable Details */}
                                    {isExpanded && (
                                        <div>
                                            {/* Order Items Table */}
                                            {orderItems.length > 0 && (
                                                <div style={styles.tableWrapper}>
                                                    <table style={styles.table}>
                                                        <thead>
                                                            <tr>
                                                                <th style={styles.th}>#</th>
                                                                <th style={styles.th}>Item</th>
                                                                <th style={styles.th}>Quantity</th>
                                                                <th style={styles.th}>To</th>
                                                                <th style={styles.th}>Earning</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {orderItems.map((item, idx) => (
                                                                <tr key={idx} style={{ backgroundColor: '#f7fafc' }}>
                                                                    <td style={styles.td}>{idx + 1}</td>
                                                                    <td style={{ ...styles.td, fontWeight: '500' }}>{item.dishName || 'Delivery'}</td>
                                                                    <td style={styles.td}>{item.quantity || 1}</td>
                                                                    <td style={styles.td}>{item.to || 'Delivery'}</td>
                                                                    <td style={{ ...styles.td, fontWeight: '600', color: '#0b5e42' }}>
                                                                        ₹{item.price || 0}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}

                                            {/* Delivery Details */}
                                            {order.apiData && (
                                                <div style={styles.detailsSection}>
                                                    <div style={styles.detailsTitle}>
                                                        <Icons.Truck /> Delivery Details
                                                    </div>
                                                    <div style={styles.infoGrid}>
                                                        {order.apiData.userName && (
                                                            <div style={styles.infoItem}>
                                                                <Icons.User /> <span style={styles.infoLabel}>User:</span>
                                                                <span style={styles.infoValue}>{order.apiData.userName} ({order.apiData.userPhone})</span>
                                                            </div>
                                                        )}
                                                        {order.apiData.vendorRestaurentname && (
                                                            <div style={styles.infoItem}>
                                                                <Icons.Vendor /> <span style={styles.infoLabel}>Vendor:</span>
                                                                <span style={styles.infoValue}>{order.apiData.vendorRestaurentname}</span>
                                                            </div>
                                                        )}
                                                        {order.apiData.deliveryDistanceKm && (
                                                            <div style={styles.infoItem}>
                                                                <Icons.Location /> <span style={styles.infoLabel}>Distance:</span>
                                                                <span style={styles.infoValue}>{parseFloat(order.apiData.deliveryDistanceKm).toFixed(2)} km</span>
                                                            </div>
                                                        )}
                                                        {order.apiData.deliveryPartnerName && (
                                                            <div style={styles.infoItem}>
                                                                <Icons.User /> <span style={styles.infoLabel}>Partner:</span>
                                                                <span style={styles.infoValue}>{order.apiData.deliveryPartnerName}</span>
                                                            </div>
                                                        )}
                                                        {order.apiData.vehicleStatus && (
                                                            <div style={styles.infoItem}>
                                                                <Icons.Truck /> <span style={styles.infoLabel}>Vehicle:</span>
                                                                <span style={styles.infoValue}>{order.apiData.vehicleStatus}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>

            <style>{`
                .spinner-border {
                    display: inline-block;
                    width: 2rem;
                    height: 2rem;
                    border: 0.25em solid currentColor;
                    border-right-color: transparent;
                    border-radius: 50%;
                    animation: spinner-border 0.75s linear infinite;
                }
                @keyframes spinner-border {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default Logisticsorders;